// src/firebase-config.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBuoQu7bariH37gIu8nxo83BTiEUEdaf2g",
  authDomain: "timetrack3r.firebaseapp.com",
  databaseURL: "https://timetrack3r-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "timetrack3r",
  storageBucket: "timetrack3r.appspot.com", 
  messagingSenderId: "106642397603",
  appId: "1:106642397603:web:c1d77d869d4e1ca081f71",
  measurementId: "G-X6324N3349",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;